import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
// import { PaperjsPage } from '../paperjspage/paperjspage';
// import { TextToSpeechPage } from '../textToSpeechpage/textToSpeechpage';
// import { Zahlen0bis9Page } from '../MathematikGrundschule/zahlen/zahlen0bis9/zahlen0bis9';
// import { SpeechToTextPage } from '../speechToTextpage/speechToTextpage';
// import { OcradPage } from '../ocradpage/ocradpage';
// import { TesseractpagePage } from '../tesseractpage/tesseractpage';
// import { PaperjsTesseractPage } from '../paperjstesseract/paperjstesseract';
// import { Zahlen0to19Page } from '../MathematikGrundschule/zahlen/zahlen0to19/zahlen0to19';
//import { Writenumber0bis9Page } from '../modalpages/writenumber0bis9/writenumber0bis9';
// import { SliderpagePage } from '../sliderpage/sliderpage';
// import { Zahlen0bis9schreibenPage } from '../MathematikGrundschule/zahlen/zahlen0bis9schreiben/zahlen0bis9schreiben';
// import { TestpagePage } from '../testpage/testpage';

@Component({
  selector: 'page-testteile',
  templateUrl: 'testteile.html'
})

export class TestteilePage {

  constructor(public navCtrl: NavController) {

  }

clickEvent(event) {
    //alert("Hast mich gedrückt");
    this.navCtrl.push('PaperjsPage');
}

clickEventZahlen0_9($event){
  console.log('this.navCtrl.push(Zahlen0bis9Page); auskommentiert')
  //this.navCtrl.push(Zahlen0bis9Page);
}

clickEventTextToSpeech($event){
  this.navCtrl.push('TextToSpeechPage');
}

clickEventSpeechToText($event){
  this.navCtrl.push('SpeechToTextPage');
}

clickEventOcrad($event){
  this.navCtrl.push('OcradPage');
}

clickEventTesseract($event){
  this.navCtrl.push('TesseractpagePage');
}

clickEventPaperjsTesseract($event){
    this.navCtrl.push('PaperjsTesseractPage');
}

// zum testen von modal
clickEventZahlen0_99($event){
  
    this.navCtrl.push('Zahlen0to19Page');
}

clickEventSliderpage($event){
this.navCtrl.push('SliderpagePage');
}

clickEventZahlen0bis9($event){
  this.navCtrl.push('Zahlen0bis9schreibenPage');
}

clickEventTest($event){
  this.navCtrl.push('TestpagePage');
}
}



// WEBPACK FOOTER //
// ./src/pages/testteile/testteile.ts